import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Network = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Network' {...props}>
    <path fill='none' stroke='#000000' strokeWidth='2' d='M7.5,7 L7.5,15.5142857 C7.5,19.7571429 13,18.3428571 13,22.1142857 L13,24 M11,10 L7.5,7 L4,10 M16.5,2 L16.5,10.440516 C16.5,14.5083612 13,13.1524128 13,16.7682752 L13,24 M13,5 L16.5,2 L20,5' />
  </StyledIcon>
);
